import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebook, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white text-black ">

      {/* Primary Address Section */}
      <section className="py-8 px-4 md:px-0 ">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left Column: Address & Contact Info */}
        <div className="text-center md:text-left">
          <h6 className="text-lg font-bold mb-2 text-myYellow">Address:</h6>
          <p className="text-sm font-bold text-black/70">
          F-23,Block -5, Rojhan Street, Clifton, Karachi,Pakistan.
          </p>

          <h6 className="text-lg font-bold mt-4 text-myYellow">Contact:</h6>
          <p className="text-sm font-bold text-black/70">
            Tel:{" "}
            <a href="tel:+922135373987" className="text-black/70 hover:underline">
              (+92-21) 35373987 , 35377174
            </a>
          </p>
          <p className="text-sm font-bold text-black/70">
            Fax:{" "}
            <a href="tel:+922135373987" className="text-black/70 hover:underline">
              (+92-21) 35830171
            </a>
          </p>
          <p className="text-sm font-bold text-black/70">
            Email:{" "}
            <a href="mailto:info@tis.edu.pk" className="text-black/70 hover:underline">
              info@tis.edu.pk
            </a>
          </p>
        </div>

        {/* Right Column: Social Media Links */}
        
        <div className="text-center sm:text-center md:text-left">
  <h6 className="text-lg  font-bold mb-4 text-myYellow">
    Reach out to us on social media:
  </h6>
  <ul className="list-disc sm:pl-10 md:pl-3 text-black text-sm">
    <li className="flex items-center gap-2 justify-center sm:justify-center md:justify-start">
      <span className="font-bold">Instagram:</span>
      <a
        href="https://www.instagram.com/tisedupk/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-black hover:text-myYellow transition duration-300"
      >
        <FaInstagram />
      </a>
    </li>
    <li className="flex items-center gap-2 mt-2 justify-center sm:justify-center md:justify-start">
      <span className="font-bold">Facebook:</span>
      <a
        href="https://www.facebook.com/TISKHI?mibextid=ZbWKwL"
        target="_blank"
        rel="noopener noreferrer"
        className="text-black hover:text-myYellow transition duration-300"
      >
        <FaFacebook />
      </a>
    </li>
    <li className="flex items-center gap-2 mt-2 justify-center sm:justify-center md:justify-start">
      <span className="font-bold">LinkedIn:</span>
      <a
        href="https://www.linkedin.com/company/the-international-school_2/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-black hover:text-myYellow transition duration-300"
      >
        <FaLinkedin />
      </a>
    </li>
  </ul>
</div>



        
      </div>
    </section>

      {/* Social Media Section */}

      {/* Footer Bottom Section */}
      <section className="py-4 text-center text-xs md:text-sm">
        <div className="container mx-auto px-4">
          <span className="opacity-80 font-bold">
            &copy; {year} THE INTERNATIONAL SCHOOL. ALL RIGHTS RESERVED.
          </span>
        
        </div>
      </section>

    </footer>
  );
};

export default Footer;
